var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMobileMenu = function SvgMobileMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#141413",
    strokeWidth: 2.4,
    d: "M21 1.2H1M21 7.2H1M21 13.2H1"
  })));
};

export default SvgMobileMenu;